<template>
  <div class="updatSeting">
    <el-row>
      <div class="model-header setting">
        <h2>Test Upload File Docx</h2>
        <div>
          <a class="item-link" href="https://demo.hn.ss.bfcplatform.vn/docx/getmarked-practice-0v2.docx" target="_blank">File Cộng hòa Xã hội mẫu</a>
          <a class="item-link" href="https://demo.hn.ss.bfcplatform.vn/docx/dethimau.docx" target="_blank">File Docx mẫu</a>
        </div>
      </div>
    </el-row>
    <el-row>
      <div class="pt-2">
          <label>
            <input type="file" id="file" ref="file" v-on:change="handleFileUpload()"/>
          </label>
          <el-button v-on:click="submitFile()" size="mini" type="success">
              <i class="fas fa-spinner fa-spin" v-if="uploadProcess"></i>
              Gửi file Docx
          </el-button>
      </div>
      <div class="pt-2" style="padding-top: 20px;">
          <label>
            <input type="file" id="fileVideo" ref="fileVideo" v-on:change="handleFileUploadVideo()"/>
          </label>
          <el-button v-on:click="submitFileVideo()" size="mini" type="success">
              <i class="fas fa-spinner fa-spin" v-if="uploadProcessVideo"></i>
              Gửi file Video
          </el-button>
      </div>
      <iframe :src="link_video" title="W3Schools Free Online Web Tutorials"></iframe>
      <div style="padding-top: 20px" v-if="loadingQuizDoc">
        <span>Hệ thống đang thực hiện chuyển đổi file docx. Vui lòng chờ 2-3 phút để hoàn tất ...</span>
      </div>
      <div style="padding-top: 20px" v-if="loadingQuizDoc == false && this.questions.length">
        <h2>Danh sách câu hỏi của File Docx vừa upload:</h2>
      </div>
      <div class="list-question" v-loading="loadingQuizDoc">
        <div class="item-question"
          :key="item.id"
          v-for="(item, index) in questions">
          <div class="content-question">
            <strong class="index">Câu {{ index + 1 }}: </strong>
            <div v-html="item.text"></div>
          </div>
          <div>
            <div class="d-flex item-option" v-for="option in item.options" :key="option.id">
              <el-switch
                active-color="#13ce66"
                inactive-color="#7f8c8d"
                v-model="option.is_answer">
              </el-switch>
              <span class="content-option" v-html="option.text"></span>
            </div>
          </div>
        </div>
      </div>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { head } from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import tinymce from 'vue-tinymce-editor'
export default {
  name: 'TestUploadDoc',
  components: {
    tinymce
  },
  metaInfo () {
    return {
      title: 'TestUploadDoc'
    }
  },
  data () {
    return {
      canSubmit: true,
      loadingQuizDoc: false,
      link_quiz: '',
      inteval: {},
      questions: [],

      // FILE
      file: {},
      uploadProcess: false,

      // FILE
      fileVideo: {},
      uploadProcessVideo: false,
      link_video: ''

    }
  },
  computed: {
    ...mapGetters('account', ['accountInfo'])
  },
  mounted () {
    this.configBreadcrumb()
  },
  beforeDestroy () {
    clearInterval(this.inteval)
  },
  methods: {
    handleFileUploadVideo () {
      this.fileVideo = this.$refs.fileVideo.files[0]
    },
    async submitFileVideo () {
      this.uploadProcessVideo = true
      let formData = new FormData()
      formData.append('file', this.fileVideo)
      let response = await axios.post('upload-video-to-server-999', formData)
      this.uploadProcessVideo = false
      if (response.data.status === 1) {
        this.link_video = response.data.link
        this.$notify({
          title: 'Thành công',
          message: 'Upload video thành công',
          type: 'success'
        })
      }
    },

    handleFileUpload () {
      this.file = this.$refs.file.files[0]
    },
    async submitFile () {
      this.questions = []
      this.uploadProcess = true
      let formData = new FormData()
      formData.append('file', this.file)
      let response = await axios.post('upload-quiz-online-8192', formData)
      this.uploadProcess = false
      if (response.data.status === 1) {
        console.log(this.link_quiz)
        this.link_quiz = response.data.link_quiz
        this.loadingQuizDoc = true
        this.autoLoadQuizDoc()
        this.$notify({
          title: 'Thành công',
          message: 'Hệ thống đang thực hiện chuyển đổi file docx. Vui lòng chờ 2-3 phút để hoàn tất ...',
          type: 'success'
        })
      } else {
        let er = response.data.errors
        let message = head(er[Object.keys(er)[0]])
        this.$notify({
          title: 'Có lỗi xảy ra',
          message: message,
          type: 'warning'
        })
      }
    },
    // Lấy action từ Vuex
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'configs-home', text: 'Test Upload File Docx' }
      ]
      this.setBreadcrumb(breadcrumb)
    },
    // Nút back lại trang Index
    backModel () {
      this.$router.push({name: 'home-index'})
    },
    autoLoadQuizDoc () {
      this.inteval = setInterval(() => {
        if (this.link_quiz) {
          this.fetchGetQuizOnline0192()
        } else {
          console.log('Không làm gì cả')
        }
      }, 10 * 1000)
    },
    fetchGetQuizOnline0192 () {
      this.loadingQuizDoc = true
      let data = {
        'link_quiz': this.link_quiz
      }
      axios.post('get-quiz-online-0192', data).then(response => {
        switch (response.code) {
          case 200:
            if (response.data.status === 'success') {
              this.loadingQuizDoc = false
              this.questions = response.data.data
              clearInterval(this.inteval)
            }
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xẳy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng contact Admin !'
            })
            break
        }
      })
    },
    // Tải dữ liệu Model xuống
    fetchModelHomeMenu () {
      this.canSubmit = false
      axios.get('configs/header-footer').then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.modelData = response.data.value
            this.modelData_ID = response.data.id
            this.logModel.logs = response.data.logs
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-content {
  padding-top: 15px;
}
.list-question {
  min-height: 100vh;
}
.item-question {
  margin-bottom: 15px;
}
.index {
  font-size: 18px;
}
.content-question {
  color: green;
  font-weight: bold;
  margin-bottom: 15px;
}
.item-option {
  margin-bottom: 5px;
}
.content-option {
  margin-left: 10px;
}
.item-link {
  margin-left: 10px;
  display: inline-block
}
</style>



// WEBPACK FOOTER //
// src/components/config-home/TestQuizDoc.vue